import {$document, APP_NAME} from '../utils/environment'
import {EVENT as TRANSITION_EVENT} from '../transitions/TransitionManager'
import AbstractModule from './AbstractModule'


const MODULE_NAME = 'AvailabilityFilter';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    'CHANGE': `change.${EVENT_NAMESPACE}`,
}

export default class extends AbstractModule {

    /**
     * Constructor.
     *
     * @return {void}
     */
    constructor(options) {
        super(options);

        this.$el.on(EVENT.CHANGE, (event) => {
            $document.triggerHandler({
                type: TRANSITION_EVENT.GOTO,
                options: {
                    transition: 'default',
                    location: this.el.options[this.el.selectedIndex].value
                }
            });
        })
    }

    /**
     * Destructor.
     *
     * @return {void}
     */
    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
        $document.off(`.${EVENT_NAMESPACE}`);
    }
}

